export const GET_GENDER_WATCHER = 'GET_GENDER_WATCHER';
export const GET_GENDER_SUCCESS = 'GET_GENDER_SUCCESS';
export const GET_GENDER_FAILED = 'GET_GENDER_FAILED';
